import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/core_values";

export default class CoreValues extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Core Values | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
